import React from 'react';
import SkeletonBone from './SkeletonBone';
import './loading.css';

/** Sidebar-style list of property rows (map page, featured strips). */
const SkeletonSidebarList = ({ count = 5 }) => (
  <div className="skeleton-list" aria-busy="true" aria-live="polite">
    {Array.from({ length: count }, (_, index) => (
      <div className="skeleton-list__item" key={index}>
        <SkeletonBone className="skeleton-list__thumb" />
        <div className="skeleton-list__text">
          <SkeletonBone style={{ height: '0.95rem', width: '70%' }} />
          <SkeletonBone style={{ height: '0.8rem', width: '45%' }} />
        </div>
      </div>
    ))}
  </div>
);

export default SkeletonSidebarList;
